<script>
	// 폰(<768px) 전용 상단 가로 탭바. 넘치면 좌우 스크롤. 태블릿/데스크톱은 좌측 GameBuilderSidebar 사용.
	// chat-builder/shell/BuilderTopTabs.svelte 와 같은 규격.
	import { createEventDispatcher } from "svelte";

	export let tabList = [];
	export let currentTab = "";

	const dispatch = createEventDispatcher();
</script>

<nav
	class="tw-flex tw-shrink-0 tw-gap-1 tw-overflow-x-auto tw-border-b tw-border-border tw-bg-background tw-px-3 tw-py-2 md:tw-hidden"
	aria-label="빌더 단계"
>
	{#each tabList as tab (tab.value)}
		<button
			type="button"
			class="tw-flex tw-shrink-0 tw-cursor-pointer tw-items-center tw-gap-0.5 tw-whitespace-nowrap tw-rounded-full tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-transition-colors {currentTab ===
			tab.value
				? 'tw-bg-primary/10 tw-text-primary'
				: 'tw-text-foreground/70 hover:tw-bg-muted hover:tw-text-foreground'}"
			on:click={() => dispatch("change", tab.value)}
		>
			{tab.label}
		</button>
	{/each}
</nav>
